import { render, staticRenderFns } from "./FormConfigurationInformation.vue?vue&type=template&id=70643c91&scoped=true"
import script from "./FormConfigurationInformation.vue?vue&type=script&lang=ts"
export * from "./FormConfigurationInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70643c91",
  null
  
)

export default component.exports